import React, {useCallback} from 'react';
import {Button, Typography} from 'lark';
import {Location} from 'history';
import {parseUrl} from '~/utils/url';
import './index.less';

const {Paragraph} = Typography;
interface Props {
    location: Location;
}

// 此组件用于在灵犀和企业微信扫码登录时, 显示授权页面, web端的二维码组件在page/login下
const QRLogin = (props: Props) => {
    const {location: {search = ''}} = props;
    // eslint-disable-next-line
    const queries: any = parseUrl(search);
    const {k: id, s: service} = queries;
    const handleClick = useCallback(
        () => {
            window.location.href = `${window.location.origin}/cas/dispatcher/qrcode/submit?k=${id}`;
        },
        [id],
    );
    return (
        <div className="qr-confirm">
            <div className="qr-confirm-img-wrapper">
                <img
                    className="qr-confirm-img"
                    srcSet="/assets/qrcode/电脑确认.png,
                        /assets/qrcode/电脑确认@2x.png 2x,
                        /assets/qrcode/电脑确认@3x.png 3x,"
                    src="/assets/qrcode/电脑确认@3x.png" alt="电脑确认"
                />
            </div>
            <Paragraph>授权电脑登录</Paragraph>
            <Paragraph>
                {service || ''}
            </Paragraph>
            <Button onClick={handleClick}>确认登录</Button>
        </div>
    );
};

export default QRLogin;
